export enum UserStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

export type IUserDelete = {
	isDeleted: boolean;
	message: string;
};

export type IUser = {
	id: string;
	accountId: string;
	email: string;
	firstName: string;
	lastName: string;
	status: UserStatus;
	phoneNumber: string;
	npi: string;
	roles: string[];
	programs: IUserPrograms[];
};

export type IUserPrograms = {
	programId: string;
	orgUnitId: {
		activeEnrollmentsCount: number;
		orgUnitId: string;
	}[];
};

export type IUserWithId = IUser & {
	id: string;
};

export type ParamsDelete = {
	userId: string;
};

export type Params = {
	accountId: string;
};

export type IUserResponse = {
	statusCode: number;
	body: IUserWithId[];
};

export interface IUserPayload {
	accountId: string;
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	npi: string;
	status: string;
	roles: string[];
	programs: {
		programId: string;
		orgUnitId: string[];
	}[];
	createdBy?: string;
	updatedBy?: string;
}

export type IUserPayloadId = IUserPayload & {
	id: string;
};

export interface IProgramOrganizationsGroup {
	organizationIdsList?: string[] | undefined;
	programId: string;
}

export interface ICreateUserPayload {
	npi?: string | undefined;
	programOrganizationsGroupList?: IProgramOrganizationsGroup[] | undefined;
	roleId: string;
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	status: string;
}
